// extracted by mini-css-extract-plugin
export default {"viewerWrapper":"FileViewer_viewerWrapper__x7FK7","pdfLoaderWrapper":"FileViewer_pdfLoaderWrapper__pqdVz","pdfLoader":"FileViewer_pdfLoader__wpIDe"};